// Applies FANUC-specific italic "i" styling to product names.
// Targets headings site-wide and any element with .js-apply-italic-i (e.g. card titles,
// Algolia results, or any client-rendered content that opts in).
// Keep product lists in sync with any server-side equivalents.

const EM = '<em class="italic-i">i</em>';

const PRODUCT_SEARCH = [
  'iHMI',
  'iB5',
  'iPendant',
  'DDR-HSiB',
  'DDR-TiB',
  'DDRiB',
  'iPC',
  'Panel i',
  'MT-LINK i',
  'Manual Guide i',
  'Power Motion i',
  'iRVision',
  'iRPickTool',
  'iRCalibration',
];

const PRODUCT_REPLACE = [
  EM + 'HMI',
  EM + 'B5',
  EM + 'Pendant',
  'DDR-HS' + EM + 'B',
  'DDR-T' + EM + 'B',
  'DDR' + EM + 'B',
  EM + 'PC',
  'Panel ' + EM,
  'MT-LINK ' + EM,
  'Manual Guide ' + EM,
  'Power Motion ' + EM,
  EM + 'RVision',
  EM + 'RPickTool',
  EM + 'RCalibration',
];

function transformText(text) {
  // Normalise bare <em>i</em> / <i>i</i> from CKEditor manual italic formatting
  text = text.replace(/<(em|i)>i<\/(em|i)>/g, EM);
  // Numeric "i" e.g. "CRX-10iA"
  let result = text.replace(/([0-9])i/g, '$1' + EM);
  // Named product strings
  for (let i = 0; i < PRODUCT_SEARCH.length; i++) {
    result = result.replaceAll(PRODUCT_SEARCH[i], PRODUCT_REPLACE[i]);
  }
  return result;
}

window.applyItalicI = function () {
  // Apply to all headings globally + any element that opts in via .js-apply-italic-i
  const targets = document.querySelectorAll('h1, h2, h3, h4, .js-apply-italic-i');

  targets.forEach((el) => {
    if (el.dataset.italicApplied) return;

    // Walk text nodes only — never touch attribute values (href, src, etc.)
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      const original = node.textContent;
      const replaced = transformText(original);
      if (replaced !== original) {
        const fragment = document.createRange().createContextualFragment(replaced);
        node.replaceWith(fragment);
      }
    });

    el.dataset.italicApplied = 'true';
  });
};

// Run once on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  window.applyItalicI();
});

// Re-run for dynamically added content (Alpine.js renders, fetch results, etc.)
const observer = new MutationObserver(() => {
  setTimeout(() => {
    if (typeof window.applyItalicI === 'function') {
      window.applyItalicI();
    }
  }, 50);
});

observer.observe(document.body, { childList: true, subtree: true });
